import React, { useState } from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
const PlayerStats = () => {
  const [adaptData, setAdaptData] = useState(false);
  const [activeStatTab, setActiveStatTab] = useState('scoring');
  const statCategories = {
    scoring: [{
      label: 'PTS/G',
      value: 21.2,
      abbr: 'PTS/G',
      percentile: 85
    }, {
      label: 'TS%',
      value: 57.7,
      abbr: 'TS%',
      percentile: 72
    }, {
      label: '2PM/G',
      value: 4.3,
      abbr: '2PM/G',
      percentile: 65
    }, {
      label: '2P%',
      value: 51.3,
      abbr: '2P%',
      percentile: 68
    }, {
      label: '2P rate',
      value: 53.2,
      abbr: '2P rate',
      percentile: 70
    }, {
      label: '3PM/G',
      value: 2.6,
      abbr: '3PM/G',
      percentile: 60
    }, {
      label: '3P%',
      value: 35.6,
      abbr: '3P%',
      percentile: 55
    }, {
      label: '3P rate',
      value: 46.8,
      abbr: '3P rate',
      percentile: 62
    }, {
      label: 'FTM/G',
      value: 4.8,
      abbr: 'FTM/G',
      percentile: 75
    }, {
      label: 'FT%',
      value: 78.2,
      abbr: 'FT%',
      percentile: 80
    }, {
      label: 'FT rate',
      value: 39.0,
      abbr: 'FT rate',
      percentile: 65
    }],
    playmaking: [{
      label: 'AST/G',
      value: 1.7,
      abbr: 'AST/G',
      percentile: 45
    }, {
      label: 'AST%',
      value: 7.9,
      abbr: 'AST%',
      percentile: 40
    }, {
      label: 'TO/G',
      value: 1.8,
      abbr: 'TO/G',
      percentile: 35
    }, {
      label: 'TO%',
      value: 8.4,
      abbr: 'TO%',
      percentile: 30
    }, {
      label: 'AST/TO',
      value: 0.9,
      abbr: 'AST/TO',
      percentile: 25
    }],
    stealing: [{
      label: 'STL/G',
      value: 1.2,
      abbr: 'STL/G',
      percentile: 65
    }, {
      label: 'STL%',
      value: 1.6,
      abbr: 'STL%',
      percentile: 60
    }, {
      label: 'BLK/G',
      value: 0.4,
      abbr: 'BLK/G',
      percentile: 30
    }, {
      label: 'BLK%',
      value: 0.8,
      abbr: 'BLK%',
      percentile: 25
    }],
    rebounding: [{
      label: 'DR/G',
      value: 3.0,
      abbr: 'DR/G',
      percentile: 55
    }, {
      label: 'DR%',
      value: 11.8,
      abbr: 'DR%',
      percentile: 50
    }, {
      label: 'OR/G',
      value: 1.4,
      abbr: 'OR/G',
      percentile: 60
    }, {
      label: 'OR%',
      value: 4.9,
      abbr: 'OR%',
      percentile: 55
    }, {
      label: 'TR/G',
      value: 4.4,
      abbr: 'TR/G',
      percentile: 58
    }, {
      label: 'TR%',
      value: 8.1,
      abbr: 'TR%',
      percentile: 52
    }]
  };
  // Function to determine bar color based on percentile
  const getPercentileColor = percentile => {
    if (percentile >= 70) return 'bg-emerald-600';
    if (percentile >= 40) return 'bg-amber-600';
    return 'bg-red-600';
  };
  const advancedStats = [{
    category: 'SCORING',
    stat: 'ORTG',
    value: 114.5
  }, {
    category: 'RIM PROT',
    stat: 'BLK_PCT',
    value: 3.2
  }, {
    category: 'DEF REB',
    stat: 'DEFREB_PCT',
    value: 24.3
  }, {
    category: 'OFFENSIVE REB',
    stat: 'OFFREB_PCT',
    value: 8.7
  }, {
    category: 'STEALING',
    stat: 'STL_PCT',
    value: 2.1
  }, {
    category: 'PLAYMAKING',
    stat: 'AST_PCT',
    value: 32.6
  }, {
    category: 'DEFENSIVE IMPACT',
    stat: 'DRTG',
    value: 105.8
  }, {
    category: 'OFFENSIVE VOLUME',
    stat: 'USAGE_PCT',
    value: 28.4
  }, {
    category: 'SHOOTING',
    stat: 'TS_PCT',
    value: 59.3
  }];
  const selectedFactors = ['2PT', '3PT', 'FT', 'SCORING', 'RIM PRO', 'STEALING'];
  return <div data-id="element-568" data-mp="3q7uw5kp5dc8n">
      {/* First Row: Combined Radar and Advanced Stats */}
      <div className="mt-6 bg-white rounded-lg shadow-md" data-id="element-569" data-mp="3lfbiknqgmh3u">
        <div className="p-4 flex justify-between items-center border-b" data-id="element-570" data-mp="3z1xsx7k9ugv">
          <h3 className="font-bold text-gray-900" data-id="element-571" data-mp="3x8r5hwy7a8v">OUR STATS</h3>
          <div className="flex items-center space-x-4" data-id="element-572" data-mp="3v4bge3t876gg">
            <div className="flex items-center" data-id="element-573" data-mp="3v7pn1o8xa1tp">
              <span className="text-sm mr-2 text-gray-600" data-id="element-574" data-mp="cyoxnekn6s7t">ADAPT DATA</span>
              <div className={`w-10 h-5 rounded-full ${adaptData ? 'bg-blue-600' : 'bg-gray-300'} relative cursor-pointer`} onClick={() => setAdaptData(!adaptData)} data-id="element-575" data-mp="805f7o59byk7">
                <div className={`absolute w-4 h-4 bg-white rounded-full top-0.5 transition-transform ${adaptData ? 'transform translate-x-5' : 'translate-x-0.5'}`} data-id="element-576" data-mp="29t3bjty8t99w"></div>
              </div>
            </div>
            <div className="relative w-48" data-id="element-577" data-mp="ub6pwpgq3arz">
              <input type="text" defaultValue="NBA" className="w-full pl-3 pr-8 py-1.5 border rounded-md text-sm text-gray-900" data-id="element-578" data-mp="gi798k57faiu" />
              <SearchIcon className="w-4 h-4 absolute right-3 top-1.5 text-gray-500" data-id="element-579" data-mp="6iymab8raw5z" />
            </div>
          </div>
        </div>

        <div className="flex" data-id="element-580" data-mp="bjdw4sttxlj7">
          {/* Radar Chart Section */}
          <div className="w-1/2 p-4 border-r" data-id="element-581" data-mp="3tophmff4nkzk">
            <h4 className="font-bold text-sm mb-3 text-gray-900" data-id="element-582" data-mp="3tq0lef8kosqo">RADAR</h4>
            <div className="relative h-64 w-64 mx-auto" data-id="element-583" data-mp="1l6j2l2nvnmh">
              {/* Radar Chart */}
              <svg viewBox="0 0 180 180" className="w-full h-full bg-[fff] pt-[0px] pb-[0px] pl-[4px] pr-[4px] mt-[0px] mb-[0px]" data-id="element-584" data-mp="1rxw19pxbezqi">
                {/* Pentagon shape */}
                <polygon points="90,9 171,67.5 139.5,162 40.5,162 9,67.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-585" data-mp="34wxv9ykbpa2i" />
                <polygon points="90,36 144,76.5 121.5,135 58.5,135 36,76.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-586" data-mp="2vuycp1tntxxg" />
                <polygon points="90,63 117,85.5 103.5,108 76.5,108 63,85.5" fill="none" stroke="#ccc" strokeWidth="1" data-id="element-587" data-mp="3nl2wozdiciy5" />
                {/* Axes */}
                <line x1="90" y1="9" x2="90" y2="162" stroke="#ccc" strokeWidth="1" data-id="element-588" data-mp="39upiwgdxqa0w" />
                <line x1="9" y1="67.5" x2="171" y2="67.5" stroke="#ccc" strokeWidth="1" data-id="element-589" data-mp="6d7horso419g" />
                <line x1="40.5" y1="162" x2="139.5" y2="162" stroke="#ccc" strokeWidth="1" data-id="element-590" data-mp="ip1ft8583mv6" />
                {/* Data polygon */}
                <polygon points="90,36 144,76.5 121.5,117 58.5,135 63,76.5" fill="rgba(75, 85, 99, 0.3)" stroke="#4B5563" strokeWidth="2" data-id="element-591" data-mp="rmbtt19fdq3s" />
                {/* Labels */}
                <text x="90" y="4.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-592" data-mp="16evu7u56xjhj">
                  Scoring
                </text>
                <text x="175.5" y="67.5" textAnchor="middle" transform="rotate(90, 175.5, 67.5)" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" style={{
                overflow: 'visible'
              }} data-id="element-593" data-mp="1kcsmwfgix5qx">
                  RIM PRO
                </text>
                <text x="139.5" y="175.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-594" data-mp="2aof0n8egax65">
                  2PT
                </text>
                <text x="40.5" y="175.5" textAnchor="middle" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-595" data-mp="1wncc8ozzhas2">
                  3PT
                </text>
                <text x="4.5" y="67.5" textAnchor="end" className="text-[10px] uppercase tracking-wider font-bold fill-gray-500" data-id="element-596" data-mp="1456xx059zsd5">
                  FT
                </text>
              </svg>
            </div>
            <div className="mt-4" data-id="element-597" data-mp="3fod7yk8sddzb">
              <div className="relative" data-id="element-598" data-mp="30xw6j0w5io2f">
                <input type="text" placeholder="Search factor to add" className="w-full pl-10 pr-4 py-2 border rounded-lg text-sm text-gray-900" data-id="element-599" data-mp="30yyxf8th4qic" />
                <SearchIcon className="w-4 h-4 absolute left-3 top-2.5 text-gray-500" data-id="element-600" data-mp="3tjyqq9off1ja" />
              </div>
              <div className="flex flex-wrap gap-2 mt-3" data-id="element-601" data-mp="2de73b0pavwa">
                {selectedFactors.map((factor, index) => <div key={index} className={`
                    px-3 py-1 text-[10px] uppercase tracking-wider font-bold rounded-full flex items-center
                    ${index === 5 ? 'bg-gray-200 text-gray-600' : 'bg-gray-900 text-white'}
                  `} data-id="element-602" data-mp="3omoti7usplkw" data-mpi={index}>
                    {factor}
                    <XIcon className="w-3 h-3 ml-1" data-id="element-603" data-mp="1hkiqodx4iul3" />
                  </div>)}
              </div>
            </div>
          </div>

          {/* Advanced Stats Table Section */}
          <div className="w-1/2 p-4" data-id="element-604" data-mp="18qxaqr9837a3">
            <h4 className="font-bold text-sm mb-3 text-gray-900" data-id="element-605" data-mp="1ct0oxnna0pz2">
              ADVANCED STATS
            </h4>
            <div className="overflow-hidden" data-id="element-606" data-mp="yspy2klyvbdw">
              <table className="min-w-full" data-id="element-607" data-mp="yrocvnb8l8ig">
                <thead data-id="element-608" data-mp="13s2lp7knwmhj">
                  <tr className="border-b" data-id="element-609" data-mp="13tdmqzmq3g4y">
                    <th className="text-left py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-610" data-mp="13q9bjiaubk4s">
                      CATEGORY
                    </th>
                    <th className="text-left py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-611" data-mp="tuxw0xrly8vz">
                      STAT
                    </th>
                    <th className="text-right py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500" data-id="element-612" data-mp="2o8pdukk3bz2i">
                      VALUE
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-613" data-mp="8k1qd4p5t1o5">
                  {advancedStats.map((stat, index) => {
                  // Generate random value between 0 and 100
                  const randomValue = Math.floor(Math.random() * 101);
                  // Determine color based on value
                  let barColor = 'bg-red-600';
                  if (randomValue >= 75) {
                    barColor = 'bg-emerald-600';
                  } else if (randomValue >= 30) {
                    barColor = 'bg-amber-600';
                  }
                  return <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : ''} data-id="element-614" data-mp="10aethbvq3o8h" data-mpi={index}>
                        <td className="py-2 text-xs font-medium text-gray-900" data-id="element-615" data-mp="371e9a3q1r0a6">
                          {stat.category}
                        </td>
                        <td className="py-2 text-xs text-gray-600" data-id="element-616" data-mp="15ywn7h5tq8n0">
                          <div className="flex items-center" data-id="element-617" data-mp="160rc16k7ukwd">
                            <div className="w-24 h-4 bg-gray-200 rounded-sm overflow-hidden" data-id="element-618" data-mp="1ayj0fqlnjovt">
                              <div className={`h-full ${barColor}`} style={{
                            width: `${randomValue}%`
                          }} data-id="element-619" data-mp="1fvri7q2w1qwj"></div>
                            </div>
                            <span className="ml-2 text-[10px] font-bold text-gray-600" data-id="element-620" data-mp="1tvaqcivp928u">
                              {randomValue}%
                            </span>
                          </div>
                        </td>
                        <td className="py-2 text-xs font-bold text-gray-900 text-right" data-id="element-621" data-mp="23ohtdx2yw65r">
                          {stat.value}
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Second Row: Four Stat Boxes */}
      <div className="grid grid-cols-4 gap-4 mt-6" data-id="element-622" data-mp="3s4zx6vm1rhnx">
        {/* Scoring Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-623" data-mp="3o3o0y78o3y6r">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-624" data-mp="3o6ajf1x3jy3r">
            SCORING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-625" data-mp="jq7yd438lqxk">
            {statCategories.scoring.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-626" data-mp="foe5vj373t8h" data-mpi={index}>
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-627" data-mp="fr0cngi9i4pn">
                  <span className="font-medium text-gray-600" data-id="element-628" data-mp="avtbafcgtc3w">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-629" data-mp="5ybbpfkc898k">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-630" data-mp="13frvvidvjcqa">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-631" data-mp="ymgv9yznns6t">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Playmaking Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-632" data-mp="11w8f83s7zpkr">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-633" data-mp="11wrxjlls8fzb">
            PLAYMAKING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-634" data-mp="15zocn2c45tyi">
            {statCategories.playmaking.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-635" data-mp="x4qcpbajtgxo" data-mpi={index}>
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-636" data-mp="x35jbozz041e">
                  <span className="font-medium text-gray-600" data-id="element-637" data-mp="1kt9oi0st4bui">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-638" data-mp="1pmm79uat1ofc">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-639" data-mp="1yzbc613yrh1n">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-640" data-mp="1uzklryicn2xn">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Stealing Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-641" data-mp="1c29noh8gefjs">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-642" data-mp="1q0hfkaqmuqo3">
            STEALING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-643" data-mp="1kza8kdwbdvih">
            {statCategories.stealing.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-644" data-mp="2wfqtgmqn14cq" data-mpi={index}>
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-645" data-mp="2wf8mow6cn7qk">
                  <span className="font-medium text-gray-600" data-id="element-646" data-mp="34feoxp10pb8f">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-647" data-mp="38hiaj6hehw7f">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-648" data-mp="3dgmnm87g4e31">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-649" data-mp="3ifz7ql6xn71x">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Rebounding Box */}
        <div className="bg-white p-4 rounded-lg shadow-md" data-id="element-650" data-mp="2zio9n3x1ejo2">
          <h3 className="font-bold mb-3 text-sm border-b pb-2 text-gray-900" data-id="element-651" data-mp="222r5cql8vp7l">
            REBOUNDING
          </h3>
          <div className="space-y-3 max-h-80 overflow-y-auto pr-1" data-id="element-652" data-mp="26zrc73px4vzr">
            {statCategories.rebounding.map((stat, index) => <div key={index} className="flex flex-col" data-id="element-653" data-mp="1zfgo8w16tso8" data-mpi={index}>
                <div className="flex justify-between items-center text-xs mb-1" data-id="element-654" data-mp="1ujhxj1sdzykn">
                  <span className="font-medium text-gray-600" data-id="element-655" data-mp="1pikfqqbah6jo">{stat.abbr}</span>
                  <span className="font-bold text-gray-900" data-id="element-656" data-mp="1kkix26hrz98q">{stat.value}</span>
                </div>
                <div className="w-full h-5 bg-gray-200 rounded-sm overflow-hidden" data-id="element-657" data-mp="1gif8cg63i85i">
                  <div className={`h-full ${getPercentileColor(stat.percentile)} flex items-center pl-2 text-white text-[10px] font-bold`} style={{
                width: `${stat.percentile}%`
              }} data-id="element-658" data-mp="1gki4lhxucxio">
                    {stat.percentile}%
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default PlayerStats;